import React, { useEffect, useState } from 'react'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
  Badge,
  Btn,
  ConfirmDialog,
  CustomDataTableHeader,
  CustomPanel,
  InputText,
  PageHeader,
  Periodo,
  ThreeDots,
  CustomDataTable,
} from '../../../../../components'
import { Fieldset } from 'primereact/fieldset'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../../assets/js/styles'
import useMovimentacaoExpedicao, { LOAD_MESSAGE } from './MovimentacaoEstoqueExpedicaoHook'
import ModalMovimentacaoEstoqueExpedicao from './ModalMovimentacaoEstoqueExpedicao'
import {
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../../../services/util/date.service'
import * as colors from '../../../../../assets/js/colors'
import { Button } from 'primereact/button'

function MovimentacaoEstoqueExpedicao({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useMovimentacaoExpedicao()
  const [globalFilter, setGlobalFilter] = useState('')

  useEffect(() => {
    localDispatch.onInit(selectedTp)
  }, [selectedTp])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SUCCESS_DELETE:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        break

      case LOAD_MESSAGE.DELETE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.deleteMovimentacaoExpedicao(
          selectedTp,
          state.selectedMovimentacao,
          parseToMysqlFormatWithTime00(state.periodo.dataInicial),
          parseToMysqlFormatWithTime23(state.periodo.dataFinal),
        )
        break

      case LOAD_MESSAGE.GET_MOVIMENTACOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMovimentacoesExpedicao(
          selectedTp,
          parseToMysqlFormatWithTime00(state.periodo.dataInicial),
          parseToMysqlFormatWithTime23(state.periodo.dataFinal),
        )
        break

      case LOAD_MESSAGE.GET_OPERACOES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getOperacoesSaida(selectedTp)
        break

      case LOAD_MESSAGE.REOPEN:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.reabrirMovimentacaoExpedicao(selectedTp, state.selectedMovimentacao)
        break

      case LOAD_MESSAGE.FINISH:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.finalizarMovimentacaoExpedicao(selectedTp, state.selectedMovimentacao)
        break

      case LOAD_MESSAGE.CREATE_CONFERENCIA:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.createConferenciaExpedicao(selectedTp, state.selectedMovimentacao.id)
        break

      case LOAD_MESSAGE.CHECK_HISTORICO:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.checkHistoricoConferencia(selectedTp, state.selectedMovimentacao)
        break

      case LOAD_MESSAGE.CHECK_REOPEN:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.checkConferenciaBeforeReopen(selectedTp, state.selectedMovimentacao)
        break

      case LOAD_MESSAGE.GET_BY_IDENTIFIER:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        localDispatch.getMovimentacaoExpedicaoByIdentifier(
          selectedTp,
          state.identifier,
          parseToMysqlFormatWithTime00(state.periodo.dataInicial),
          parseToMysqlFormatWithTime23(state.periodo.dataFinal),
        )
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.successMessage) {
      dispatch(showMessageBox(state.successMessage, null))
      localDispatch.resetState()
    }
  }, [state.successMessage])

  useEffect(() => {
    if (state.pathToRedirect) {
      history.push(state.pathToRedirect, {
        selectedMovimentacao: state.selectedMovimentacao,
      })
    }
  }, [state.pathToRedirect])

  return (
    <div>
      <PageHeader>8.5 - Movimentacao de Estoque - Expedição</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel
          onNovo={() => localDispatch.onBtnNovo(selectedTp)}
          showBtnNovo={selectedTp}
          onVoltar={history.goBack}
        >
          <div className="p-grid">
            <div className="p-col-4">
              <Periodo
                btnEnabled={selectedTp}
                periodoFinal={state.periodo.dataFinal}
                periodoInicial={state.periodo.dataInicial}
                onPesquisar={localDispatch.onPesquisar}
              />
            </div>
            <div className="p-col-12">
              <Fieldset legend="Filtro" toggleable collapsed={true} className="p-mb-3">
                <div className="p-grid p-align-center">
                  <div className="p-col-4">
                    <InputText
                      label="Nota Fiscal de Expedição:"
                      value={state.identifier}
                      onChange={value => localDispatch.onIdentifierChange(value)}
                    />
                  </div>
                  <div className="p-col-2" style={{ marginTop: 32 }}>
                    <Btn
                      onClick={() => localDispatch.onBuscarByIdentifier(selectedTp)}
                      disabled={!selectedTp || !state.identifier}
                    >
                      Buscar
                    </Btn>
                  </div>
                </div>
              </Fieldset>
            </div>
            <div className="p-col-12">
              <CustomDataTable
                value={state.movimentacoes}
                emptyMessage="Não existe movimentação de expedição para o TP selecionado."
                paginator={true}
                rows={10}
                globalFilter={globalFilter}
                header={<CustomDataTableHeader onChange={setGlobalFilter} />}
              >
                <Column field="id" header="Código" style={tableCellCentered()} />
                <Column field="created_at" header="Criado Em" style={tableCellCentered()} />
                <Column field="name" header="Nome" />
                <Column field="company_name" header="Empresa" style={{ width: 200 }} />
                <Column
                  field="status"
                  header="Status"
                  style={tableCellCentered(200)}
                  body={mov => <BadgeTypeMovimentacaoExpedicao status={mov.status} />}
                />
                <Column
                  header="Menu"
                  style={tableCellCentered(70)}
                  body={mov => (
                    <ThreeDots
                      items={localDispatch.getMenuItems()}
                      onClick={item => localDispatch.onMenuItemClicked(item, mov, selectedTp)}
                    />
                  )}
                  bodyStyle={tableCellCentered()}
                />
                <Column
                  header="Relátorio"
                  style={{ width: 100, maxHeight: 30 }}
                  body={mov => (
                    <div
                      style={{
                        width: '100%',
                        display: 'inline-flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        style={{ backgroundColor: '#0f929e' }}
                        disabled={
                          ![
                            'Reaberto',
                            'Em Expedição',
                            'Expedido',
                            'Finalizado',
                            'Em Conferencia',
                            'Conferido',
                          ].includes(mov.status)
                        }
                        onClick={() =>
                          localDispatch.onMenuItemClicked('Ver Relatório', mov, selectedTp)
                        }
                        icon="pi pi-file"
                        label={undefined}
                      />
                    </div>
                  )}
                />
              </CustomDataTable>
            </div>
          </div>
        </CustomPanel>
      </div>
      <ModalMovimentacaoEstoqueExpedicao
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        onModalSave={localDispatch.onModalSave}
        data={state.modal.data}
        selectedTp={selectedTp}
        operacoes={state.operacoes}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmDelete.show}
        title="Atenção"
        content={<span>Deseja realmente apagar a movimentação?</span>}
        onCancelar={localDispatch.onModalConfirmDeleteClose}
        onOk={localDispatch.onModalConfirmDeleteOk}
      />
      <ConfirmDialog
        isVisible={state.modalConfirmReopen.show}
        title="Atenção"
        content={
          <span style={{ display: 'block', maxWidth: 340 }}>
            Esta expedição já possui conferência registrada, ao reabri-la todo o progresso será
            perdido. Deseja prosseguir?
          </span>
        }
        onCancelar={localDispatch.onModalConfirmReopenClose}
        onOk={localDispatch.onModalConfirmReopenOk}
      />
    </div>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(MovimentacaoEstoqueExpedicao))

export function BadgeTypeMovimentacaoExpedicao({ status }) {
  switch (status) {
    case 'Aguardando Importação':
      return <Badge color={colors.verde}>{status}</Badge>
    case 'Importado':
      return <Badge color={colors.vinho}>{status}</Badge>
    case 'Em Expedição':
      return <Badge color={colors.black}>{status}</Badge>
    case 'Expedido':
      return <Badge color={colors.laranja}>{status}</Badge>
    case 'Reaberto':
      return <Badge color={colors.pink}>{status}</Badge>
    case 'Finalizado':
      return <Badge color={colors.azul_escuro}>{status}</Badge>
    case 'Em Conferencia':
      return <Badge color={colors.vermelho_hover}>{status}</Badge>
    case 'Conferido':
      return <Badge color={colors.verde_hover}>{status}</Badge>
    default:
      return <Badge color={colors.vermelho}>ERRO</Badge>
  }
}
